class equalHeights {

    constructor(className, breakpoint = 3) {
        this.tallest = 0;
        this.brkpt = breakpoint;
        this.elements = document.querySelectorAll(className);
        this.resize();
    }

    resize() {
        if (_.isUndefined(Breakpoint) === false) {
            if (Breakpoint.grpInt >= this.brkpt) {
                this.init();
            } else {
                this.autoHeight();
            }
        }
    }

    init() {
        this.getHeights();
        this.setHeights();
    }

    getHeights() {
        if (_.isNull(this.elements) === false) {
            Array.prototype.forEach.call(this.elements, (el, i) => {
                const eleHeight = el.offsetHeight; 
                this.tallest = (eleHeight > this.tallest ? eleHeight : this.tallest);
            });
        }
    }

    setHeights() {
        if (_.isNull(this.elements) === false) {
            Array.prototype.forEach.call(this.elements, (el, i) => {
                el.style.height = `${this.tallest}px`;
            });
        }
    }

    autoHeight() {
        if (_.isNull(this.elements) === false) {
            Array.prototype.forEach.call(this.elements, (el, i) => {
                el.style.height = 'auto';
            });
        }
    }
}
module.exports = equalHeights;